export default __webpack_public_path__ + "static/media/pizza.cf94aeab.svg";